import { all, call, put, takeLatest } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import { listCustomerProductRatings } from 'redux/customerProductRating/actions';

import * as api from './api';
import * as types from './constants';

function* listCustomerPastPurchasesSaga() {
  try {
    yield call(removeAPIError);
    const response = yield call(api.listPastPurchases);
    yield put({
      type: types.CUSTOMER_PAST_PURCHASES_LIST_SUCCESS,
      payload: response.data
    });
    if (Array.isArray(response.data.data) && response.data.data.length > 0) {
      yield put(listCustomerProductRatings());
    }
  } catch (error) {
    yield put({ type: types.CUSTOMER_PAST_PURCHASES_LIST_FAILURE, error });
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(
    types.CUSTOMER_PAST_PURCHASES_LIST_REQUEST,
    listCustomerPastPurchasesSaga
  );
}

export default function* customerPastPurchasesSagas() {
  yield all([watchList()]);
}
